import React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';

import { getMainColor } from '../theme';

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin: ${({ margin }) => margin || '0px 5px 4px 0px'};
  &.no-margin {
    margin: 0;
  }
  cursor: ${({ cursorType }) => cursorType || 'auto'};
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
`;

const Checkbox = ({
  name,
  className,
  checked,
  onChange,
  readOnly,
  fillColor = getMainColor(),
  cursorType,
  margin,
  disabled = false,
  onClick
}) => (
  <CheckboxContainer className={className} cursorType={cursorType} margin={margin} onClick={onClick}>
    <HiddenCheckbox readOnly={readOnly} name={name} checked={checked} onChange={onChange} disabled={disabled} />
    <StyledCheckbox checked={checked}>
      <Icon name={checked ? 'checkbox' : 'unCheckbox'} size={100} margin='0px' svgPathFill={checked && fillColor} />
    </StyledCheckbox>
  </CheckboxContainer>
);

export default Checkbox;
